export const MANAGE_TAGS_AND_FOLDER = {
  SAVE_TO_FOLDER_BUTTON: { key: 'SAVE_TO_FOLDER_BUTTON', value: 'Save to folder' },
  MANAGE_TAGS_BUTTON: { key: 'MANAGE_TAGS_BUTTON', value: 'Manage Tags' },
};

export const META_TAGS = {
  TITLE: { key: 'META_TAGS.TITLE', value: 'Meta Tags' },
  ADD_META_TAG_TOOLTIP: { key: 'META_TAGS.ADD_META_TAG_TOOLTIP', value: 'Add meta tag' },
  KEY_PLACEHOLDER: { key: 'META_TAGS.KEY_PLACEHOLDER', value: 'Enter key' },
  VALUE_PLACEHOLDER: { key: 'META_TAGS.VALUE_PLACEHOLDER', value: 'Enter value' },
  KEY_REQUIRED: { key: 'META_TAGS.KEY_REQUIRED', value: 'Key is required' },
  VALUE_REQUIRED: { key: 'META_TAGS.VALUE_REQUIRED', value: 'Value is required' },
  DUPLICATE_ERROR: { key: 'META_TAGS.DUPLICATE_ERROR', value: 'This key-value pair already exists' },
  KEY_EXISTS_ERROR: { key: 'META_TAGS.KEY_EXISTS_ERROR', value: 'This key already exists. Please use a different key.' },
  ADD_SUCCESS: { key: 'META_TAGS.ADD_SUCCESS', value: 'Meta tag added successfully' },
  DELETE_SUCCESS: { key: 'META_TAGS.DELETE_SUCCESS', value: 'Meta tag deleted successfully' },
  FETCH_ERROR: { key: 'META_TAGS.FETCH_ERROR', value: 'Failed to fetch meta tags' },
  SAVE_ERROR: { key: 'META_TAGS.SAVE_ERROR', value: 'Failed to save meta tags' },
};